import create from 'zustand';
import { FeatureFlagsState } from '../types';
import FeatureFlags from '../types/feature-flags.types';

const useFeatureFlagsStore = create<FeatureFlagsState>((set) => ({
  featureFlags: [],
  setFeatureFlags: (featureFlags: FeatureFlags[]) => {
    set(() => {
      return {
        featureFlags,
      };
    });
  },
}));

export default useFeatureFlagsStore;
